import api from "./Api";

class AssistantService {
  normalizeResponse(result) {
    const normalizedResult = result || {};
    const data = normalizedResult.Data || normalizedResult.data || null;

    if (!data) {
      return normalizedResult;
    }

    normalizedResult.Data = {
      answer: data.answer ?? data.Answer ?? "",
      provider: data.provider ?? data.Provider ?? "",
      model: data.model ?? data.Model ?? "",
      usage: data.usage ??
        data.Usage ?? {
          promptTokens: null,
          completionTokens: null,
          totalTokens: null,
        },
      warnings: data.warnings ?? data.Warnings ?? [],
      suggestedActions: data.suggestedActions ?? data.SuggestedActions ?? [],
    };

    return normalizedResult;
  }

  PostChat(payload) {
    return api.post("/v1/Assistant/Chat", payload).then((response) => {
      return this.normalizeResponse(response.data);
    });
  }

  PostHelp(payload) {
    return api.post("/v1/Assistant/Chat/Help", payload).then((response) => {
      return this.normalizeResponse(response.data);
    });
  }

  PostReport(payload) {
    return api.post("/v1/Assistant/Chat/Report", payload).then((response) => {
      return this.normalizeResponse(response.data);
    });
  }

  PostErrorExplainer(payload) {
    return api
      .post("/v1/Assistant/Chat/ErrorExplainer", payload)
      .then((response) => {
        return this.normalizeResponse(response.data);
      });
  }

  PostAssistantTourSeen() {
    return api.post("/v1/Assistant/Tour/Seen").then((response) => {
      return response.data;
    });
  }

  PostByMode(mode, payload) {
    switch ((mode || "").toLowerCase()) {
      case "report":
        return this.PostReport(payload);
      case "error_explainer":
        return this.PostErrorExplainer(payload);
      case "help":
        return this.PostHelp(payload);
      default:
        return this.PostChat(payload);
    }
  }
}

export default new AssistantService();
